import React from 'react';
import { Subscriptions } from './Subscriptions';
import ReactLoading from 'react-loading';

export const SubscriptionsPage = props => {

    const [notLoading, setNotLoading] = React.useState(true);

    const redirectHome = () =>{
        props.history.push('/home');
        
    }

    //Handles the redirect of expired session
    const sessionRef = (node)=>{
        if(node === null){
            window.location.replace(window.location.origin);
        }
    }

    const handleClick = (subscriptionsDetails) => {
        setNotLoading(false);

        fetch(localStorage.getItem('server') + 'subscription', {
            method: 'POST',
            headers: {
                token: sessionStorage.getItem('token'),
                memberNumber: sessionStorage.getItem('memberNumber')
            },
            body: JSON.stringify(subscriptionsDetails)
        })
        .then(function(response){
            return response.json();
        })
        .then(function(data){
            if(data.status === 401){
                // console.log("Invalid Token - Redirecting to login");
                props.history.push("");
            } else if(data.status === 429){
                alert.show(
                    <span ref={sessionRef}>
                        Too many requests. Please try again later.
                    </span>
                    , {
                        title: "Uh Oh..."
                });
            } else {
                if(data.status === 200){
                    // props.history.push('/members/home');
                    props.history.push({
                        pathname: '/home',
                        savePref: true
                    });
                } else {
                    setNotLoading(true);
                    // console.log("Please select at least one option");
                    setNotLoading(true);
                }
            }
        });
    }

    const saveData = (formData) =>{
        if(window.location.pathname !== '/subscriptions'){
            props.saveSubscriptions(formData);
        }
    }

    return(
        <div>
            <div className="overlay" hidden={notLoading}>
            <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
            </div>
            <Subscriptions saveData={saveData} redirectHome={redirectHome} submit={handleClick} isEdited={props.isEdited} subscriptionsData={props.subscriptionsData}/>
        </div>
    );
}